import {
  ReportFinancesSummaryData,
  ResultFinancesByDatesData,
  ResultFinancesByStudentsData,
} from 'app/dataTypes/reports/data/common/financesSummary'

import SimpleDate from 'app/common/classes/simple-date'
import { FinancesSummaryDetailsGroup } from 'app/dataTypes/reports/data/common/financesSummary'

import { convertByStudents, convertTotals } from './financesSummaryByStudents'
import { convertByDates } from './financesSummaryByDates'
import { extractSecondDateFromTitle } from './extractSecondDateFromTitle'

export type ApiItemByDates = {
  date: string
  balance_before: number
  balance_before_exists: boolean
  balance_after: number
  balance_after_exists: boolean
  payments: number
  payments_negative: number
  correction_payments: number
  correction_payments_negative: number
  write_offs: number // Списания
  payments_result: number // Пополнения
  correction_payments_result: number // Пополнения корректирующие
  check: number // Сверка, доступна только для стандартной группировке по датам
}

export type ApiResultFinancesByDates = {
  by_students: false
  rows: Array<ApiItemByDates>
  title_comment: string
  title: string
}

export type ApiItemByStudents = {
  student_name: string
  student_klass: string
  balance_before: number
  balance_before_exists: boolean
  balance_after: number
  balance_after_exists: boolean
  payments: number
  payments_negative: number
  correction_payments: number
  correction_payments_negative: number
  write_offs: number
  payments_result: number
  correction_payments_result: number
}

export type ApiTotals = {
  payments: number
  corrections: number
  write_offs: number
  balance_after: number
  balance_before: number
}

export type ApiResultFinancesByStudents = {
  by_students: true
  rows: Array<ApiItemByStudents>
  title_comment: string
  title: string
  totals: ApiTotals
}

export type ApiResultFinancesSummary = ApiResultFinancesByStudents | ApiResultFinancesByDates

export const convertResultFinancesSummary = (
  res: ApiResultFinancesSummary,
): ReportFinancesSummaryData => {
  const { rows, by_students: byStudents, title } = res
  const periodFinalDate = extractSecondDateFromTitle(title)
  const nullValueForFinalDate =
    periodFinalDate !== null &&
    periodFinalDate === SimpleDate.createToday().getStringFormatted('DD.MM.YYYY')

  if (byStudents) {
    const result: ResultFinancesByStudentsData = {
      groupBy: FinancesSummaryDetailsGroup.Students,
      title,
      rows: convertByStudents(rows, nullValueForFinalDate),
      totals: convertTotals(res.totals, nullValueForFinalDate),
    }
    return result
  }
  const result: ResultFinancesByDatesData = {
    groupBy: FinancesSummaryDetailsGroup.Dates,
    title,
    rows: convertByDates(rows, nullValueForFinalDate),
  }
  return result
}
